import { Box, Button, Chip, Grid, Typography } from '@mui/material';
import React, { useCallback, useEffect, useMemo, useState } from 'react'

import { NavigateFunction, useLocation, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as AddSquare } from '../../../assets/icons/add-square-green.svg'
import { ReactComponent as Document } from '../../../assets/icons/document.svg'

import { useTranslation } from 'react-i18next';
import NavigateListCustom from '../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../routes/routeName';
import { ButtonOutlined, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import InputTextField from '../../../components/input/inputTextField';
import UploadFile from '../../../components/upload/UploadFile';
import { alertError, alertSuccess, swalError, swalSuccess } from '../../../components/alert/swal';
import { formatFileSize, handleTypingNumber } from '../../../utils/app.utils';
import { my_the_sis_progress_data, ThesisProgressApi } from '../../../api/thesis-progress/thesis-progress.api';
import StepperCustom from '../../../components/step/Stepper';
import CheckBoxCustom from '../../../components/checkbox/CheckBoxCustom';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import TableCustom from '../../../components/table/tableCustom';
import { useDropzone } from 'react-dropzone';
import moment from 'moment';
import { THESIS_PROGRESS_STATUS, thesis_progress_step_data, THESIS_PROGRESS_STEP_ENUM } from './enum';
import { produce } from 'immer';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { RootState } from '../../../store/store';


export default function StudentsAddThesisProgress() {
    const { t } = useTranslation();
    const location = useLocation()
    const dispatch = useDispatch();
    const pathname = location.pathname;
    const advisor_request_name = location.state?.advisor_request_name || null;
    const base_api_url = useSelector((state: RootState) => state.api.image_api);

    const defaultState = {
        thesis_name: advisor_request_name || "",
        thesis_progress_desc: "",
        thesis_progress_percent: "",
        id_thesis_progress_file: []
    }

    const allStep: any[] = useMemo(() => [
        { name: t('ข้อมูลความคืบหน้า'), isAccept: true, icon: null, disabled: false },
        { name: t('การตอบกลับจากอาจารย์ที่ปรึกษา'), isAccept: true, icon: null, disabled: false },

    ], [t,]);
    const navigate: NavigateFunction = useNavigate();
    const search_params = new URLSearchParams(location.search);
    const mode = search_params.get("mode");
    const is_view = mode === 'VIEW'
    const { id } = useParams();
    const [step, setStep] = useState<any>(0);

    const [form, setForm] = useState<any>(defaultState);


    const handleUpdate = async (file: any, index: number) => {
        const formData = new FormData();
        formData.append("file", file[0]);
        await ThesisProgressApi.uploadMyProgress(formData).then((res: any) => {
            if (res.status < 300) {
                setForm({
                    ...form, id_thesis_progress_file: form?.id_thesis_progress_file?.map((item: any, i: number) => {
                        return i === index ? res.data : item
                    })
                })
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })
    }

    const handleUploadFile = async (files: File[]): Promise<number[]> => {
        try {
            let id_thesis_progress_files = []
            const upload_promise = files?.map(async (file) => {
                const formData = new FormData();
                formData.append('file', file);
                return await ThesisProgressApi.uploadMyProgress(formData).then((res) => {
                    return res.data?.id_thesis_progress_file
                })
            })
            id_thesis_progress_files = await Promise.all(upload_promise)
            if (id_thesis_progress_files?.length > 0) {
                return id_thesis_progress_files
            } else {
                return []
            }
        } catch (err) {
            console.log(err, 'err')
            return [];
        }
    }


    const handleSubmit = async () => {
        let id_thesis_progress_file: number[] = [];
        const progress_data_active = progress_data?.filter((x) => x?.status == THESIS_PROGRESS_STATUS.ACTIVE);
        const id_thesis_progress_file_api: number[] = files?.filter((x) => x?.id_thesis_progress_file)?.map((list) => list?.id_thesis_progress_file);
        if (files?.length > 0) {
            const id_files = await handleUploadFile(files?.filter((x) => x?.file instanceof File).map((list) => list?.file));
            id_thesis_progress_file = [...id_thesis_progress_file, ...id_files]
        }
        if (id_thesis_progress_file_api?.length > 0) {
            id_thesis_progress_file = [...id_thesis_progress_file, ...id_thesis_progress_file_api];
        }

        const body: my_the_sis_progress_data = {
            thesis_name: form?.thesis_name || "",
            thesis_progress_desc: form?.thesis_progress_desc || "",
            thesis_progress_percent:
                progress_data_active?.sort((x, y) => x - y?.seq)[progress_data_active?.length - 1]?.thesis_progress_percent ||
                progress_data_active?.sort((x, y) => x - y?.seq)[progress_data_active?.length - 1]?.thesis_progress_step_percent ||
                "",
            id_thesis_progress_file: mode === 'SEND' ? [] : id_thesis_progress_file,
            clone_thesis_progress_file_id: mode === 'SEND' ? id_thesis_progress_file : undefined,
            thesis_progress_step: progress_data?.length > 0 ? progress_data?.map((list) => {
                return {
                    id_thesis_progress_step: mode === 'SEND' ? null : list?.id_thesis_progress_step || null,
                    seq: list?.seq || null,
                    status: list?.status,
                    thesis_progress_step_name: list?.thesis_progress_step_name,
                    thesis_progress_step_status: list?.thesis_progress_step_status,
                    thesis_progress_step_percent: list?.thesis_progress_percent || list?.thesis_progress_step_percent
                }
            }) : []
            // id_thesis_progress_file: form?.id_thesis_progress_file?.filter((item: any) => item?.id_thesis_progress_file)?.map((item: any) => {
            //     return item?.id_thesis_progress_file?.toString()
            // }) || "",
        }
        dispatch(setLoading());
        if (mode === 'EDIT') {
            await ThesisProgressApi.patchMyThesisProgress(body, id).then((res: any) => {
                if (res.status < 300) {
                    alertSuccess(t('แก้ไขความคืบหน้า เรียบร้อยแล้ว'))
                    navigate(routeName.students.EThesisProgress);
                    // handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                alertError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await ThesisProgressApi.postMyThesisProgress(body).then((res: any) => {
                if (res.status < 300) {
                    alertSuccess(t('ส่งความคืบหน้า เรียบร้อยแล้ว กรุณารออาจารย์ที่ปรึกษาตรวจสอบ'))
                    navigate(routeName.students.EThesisProgress);
                    // handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                alertError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }
    const handleGetOldFile = async () => {
        await ThesisProgressApi.oldFileThesis().then((res) => {
            if (res.status < 300) {
                const response: any[] = res.data?.data || [];
                if (response?.length > 0 && !id) {
                    set_files((prev) => ([...prev, ...response]))
                }
                // console.log(response, 'response')
            }
        }).catch((err) => {
            console.log(err)
        })
    }
    const getDetail = async () => {
        dispatch(setLoading());
        await ThesisProgressApi.findByIdMyThesisProgress(id).then((res: any) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                // console.log(res.data.data);
                const files_response: any[] = res.data?.data?.file || [];
                const file_approve_res: any[] = response?.approve?.file_approve || [];
                const thesis_progress_step: any[] = res.data?.data?.thesis_progress_step || [];
                if (thesis_progress_step?.length > 0) {
                    set_progress_data(thesis_progress_step);
                }
                if (file_approve_res?.length > 0) {
                    set_file_approve(file_approve_res);
                }
                if (files_response?.length > 0) {
                    set_files(files_response);
                }
                setForm({ ...res.data.data, id_thesis_progress_file: res.data.data.file })
                // loadData()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }



    // FIX
    const [progress_data, set_progress_data] = useState<any[]>([]);
    const [files, set_files] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, _setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("");
    const [sortType, setSortType] = useState<string>("ASC");
    const [file_approve, set_file_approve] = useState<any[]>([]);

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };

    const handleToggleProgressStatus = (status: 'active' | 'inactive', index: number) => {
        set_progress_data((prev) =>
            produce(prev, (draft) => {
                draft[index].status = status;
                if (status === "inactive") {
                    for (let i = index + 1; i < draft.length; i++) {
                        draft[i].status = "inactive";
                    }
                } else {
                    // ถ้ากด active → ตัวก่อนหน้าจะ active ได้ แต่หลังจากนี้ห้ามข้าม
                    // (no-op หรือจะ validate เพิ่มก็ได้)
                }
            })
        );
    };
    const handleDeleteFile = (index: number) => {
        set_files((prev) => prev.filter((_, i) => i !== index))
    }
    const onDrop = useCallback((acceptedFiles: File[]) => {
        const files = acceptedFiles?.map((list) => ({ file: list }))
        set_files((prev) => ([...prev, ...files]))
    }, [])
    const { getRootProps, getInputProps } = useDropzone({
        multiple: true,
        onDrop, accept: {
            'application/pdf': ['.pdf'],
        }
    })
    const headCells = [
        {
            id: "#",
            width: '80px',
            sortable: false,
            disablePadding: false,
            align: "center",
            label: is_view ? <div className='flex justify-start'>ไฟล์แนบ</div> : <div {...getRootProps()} className='flex justify-start items-center'>
                <input {...getInputProps()} />
                <Button sx={{ color: "white" }} startIcon={<AddSquare />}>ไฟล์แนบ</Button>
            </div>,
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '150px',
            label: "",
        },
    ];

    const renderData = (objData: any, no: any) => {
        const index = no;
        no = page * pageLimit - pageLimit + no + 1;
        const { id_thesis_progress, file_path, file_name, file, file_size } =
            objData;

        const is_instance_of_file = file instanceof File ? true : false
        const format_file_size = formatFileSize(file_size ? Number(file_size) : file?.size);
        const file_date = moment().format("DD/MM/YY");

        const objRenderData = {
            key: id_thesis_progress,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "start",
                    label: `${file_name ? file_name : file?.name || ""} ${format_file_size} ${file_date}`,
                },
                {
                    option: "COMPONENT",
                    align: "end",
                    component: (
                        <div className='flex justify-end items-center'>
                            <OptionsButtonCustom
                                enableView
                                enableDelete={!is_view}
                                onViewClick={() => {
                                    if (is_instance_of_file) {
                                        window.open(URL.createObjectURL(file), '_blank')
                                    } else {
                                        window.open(`${base_api_url}/${file_path}${file_name}`)
                                    }
                                }}
                                onDeleteClick={() => {
                                    handleDeleteFile(index)
                                }}

                            />
                        </div>
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };


    const handleGetProgressDefault = async () => {
        dispatch(setLoading());
        await ThesisProgressApi.stepProgress().then((res) => {
            if (res.status < 300) {
                const response = res.data?.data || [];
                set_progress_data(response);

            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }

    useEffect(() => {
        handleGetOldFile();
    }, [])


    useEffect(() => {
        if (!id) {
            handleGetProgressDefault();
        }
    }, [])

    // type ThesisProgressItem = {
    //     id: number;
    //     title: string;
    //     progress: number;      // %
    //     status: string;        // เช่น "ยังไม่ดำเนินการ" / "กำลังดำเนินการ" / "เสร็จสิ้น"
    //     checked: boolean;      // ติ๊กแล้วหรือยัง
    // };

    // const THESIS_PROGRESS_MOCK: ThesisProgressItem[] = [
    //     { id: 1, title: "บทคัดย่อฉบับภาษาอังกฤษ", progress: 10, status: "ยังไม่ดำเนินการ", checked: true },
    //     { id: 2, title: "กิตติกรรมประกาศ", progress: 16, status: "ยังไม่ดำเนินการ", checked: true },
    //     { id: 3, title: "สารบัญ", progress: 22, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 4, title: "สารบัญตาราง", progress: 28, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 5, title: "สารบัญภาพ", progress: 34, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 6, title: "บทที่ 1 บทนำ", progress: 40, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 7, title: "บทที่ 2 เอกสารและงานวิจัยที่เกี่ยวข้อง", progress: 46, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 8, title: "บทที่ 3 วิธีดำเนินการวิจัย", progress: 52, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 9, title: "บทที่ 4 ผลการวิเคราะห์ข้อมูล", progress: 58, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 10, title: "บทที่ 5 สรุป อภิปรายผล และข้อเสนอแนะ", progress: 64, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 11, title: "บรรณานุกรม", progress: 70, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 12, title: "ใบแทรกรูปภาพ", progress: 76, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 13, title: "ภาคผนวก", progress: 85, status: "ยังไม่ดำเนินการ", checked: false },
    //     { id: 14, title: "ประวัติผู้วิจัย", progress: 100, status: "ยังไม่ดำเนินการ", checked: false },
    // ];


    useEffect(() => {
        if (id) {
            getDetail()
        }
    }, [])

    useEffect(() => {
        if (!advisor_request_name) {
            navigate(routeName.students.EThesisProgress)
        }

    }, [advisor_request_name])

    console.log(files, 'files')

    return (
        <div className="h-auto">
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("ความคืบหน้าวิทยานิพนธ์/ดุษฎีนิพนธ์"),
                        key: "1",
                        pathName: routeName.students.EThesisProgress,
                    },
                    {
                        name: t(id ? "รายละเอียดวิทยานิพนธ์" : "เพิ่มวิทยานิพนธ์"),
                        key: "2",
                        pathName: pathname
                    },

                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">{form?.approve ? 'ข้อมูลความคืบหน้า' : 'เพิ่มวิทยานิพนธ์'}</Typography>
            </section>
            {form?.thesis_progress_status !== 'WAITING' && mode === 'VIEW' &&
                <section className='w-full max-w-fit m-auto'>
                    <StepperCustom
                        // sx={{ maxWidth: "400px" }}
                        sx={{ maxWidth: "fit-content" }}
                        step={step}
                        setStep={(num: number) => {
                            // dispatch(setStep(num));
                            setStep(num)
                        }}
                        stepLabel={allStep}
                        view
                    // view={is_accept}
                    />
                </section>}
            {step === 0 &&
                <section className="my-4">
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('ชื่อวิทยานิพนธ์')}
                                placeholder={t('ชื่อวิทยานิพนธ์')}
                                required
                                value={form?.thesis_name || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setForm({ ...form, thesis_name: e.target.value })
                                }}
                                disabled

                            />
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('รายละเอียด')}
                                placeholder={t('รายละเอียด')}
                                value={form?.thesis_progress_desc || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setForm({ ...form, thesis_progress_desc: e.target.value })
                                }}
                                helperText={
                                    ""
                                }
                                disabled={mode === 'VIEW'}
                                multiline
                                minRow={6}
                                inputHeight={'auto'}
                            />
                        </Grid>
                        {/* <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('เปอร์เซ็นต์ความคืบหน้า')}
                                placeholder={t('เปอร์เซ็นต์ความคืบหน้า')}
                                value={form?.thesis_progress_percent || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    setForm({ ...form, thesis_progress_percent: e.target.value })
                                }}
                                helperText={
                                    ""
                                }
                                onkeypress={handleTypingNumber}
                                disabled={mode === 'VIEW'}
                                required
                            />
                        </Grid> */}
                    </Grid>


                    <Box my={2}>
                        <Typography my={1} variant='h5'>
                            ความคืบหน้า
                        </Typography>
                        {progress_data?.map((list, index) => {
                            return (
                                <Box key={index + 1} className="grid grid-cols-12 gap-4">
                                    <span className='col-span-12 md:col-span-3 xl:col-span-3'>
                                        <CheckBoxCustom
                                            checked={list?.status === THESIS_PROGRESS_STATUS.ACTIVE}
                                            disabled={

                                                progress_data[index - 1]?.status !== THESIS_PROGRESS_STATUS.ACTIVE &&
                                                index !== 0 ||
                                                is_view ||
                                                list?.thesis_progress_step_status === THESIS_PROGRESS_STEP_ENUM.SUCCESS
                                            }
                                            setChecked={(st) => handleToggleProgressStatus(st ? THESIS_PROGRESS_STATUS.ACTIVE : THESIS_PROGRESS_STATUS.INACTIVE, index)}
                                            label={`${list?.seq || ""}.${list?.thesis_progress_step_name || ""}`}
                                        />
                                    </span>
                                    <span className='col-span-12 md:col-span-3 xl:col-span-3'>
                                        {list?.thesis_progress_percent || list?.thesis_progress_step_percent || "-"} %
                                    </span>
                                    <span className='col-span-12 md:col-span-3 xl:col-span-3'>
                                        <Chip
                                            color={list?.thesis_progress_step_status === THESIS_PROGRESS_STEP_ENUM.SUCCESS ? "success" : undefined}
                                            label={thesis_progress_step_data?.find((x) => x?.value === list?.thesis_progress_step_status)?.label || ""}
                                        />
                                    </span>
                                </Box>
                            )
                        })}
                    </Box>
                    <section className="w-full mt-10">
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={
                                files?.map((data: any, i: any) => {
                                    return renderData(data, i);
                                })
                            }
                            hidePagination
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                        <Typography variant='h6'>{t("ไฟล์แนบ")}</Typography>
                        {mode !== 'VIEW' && <AddSquare onClick={() => setForm({ ...form, id_thesis_progress_file: form?.id_thesis_progress_file?.length > 0 ? [...form?.id_thesis_progress_file, {}] : [{}] })} />}
                    </div>
                    {form?.id_thesis_progress_file?.map((item: any, index: number) => {
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

                                {item?.file_name ?
                                    <div style={{
                                        border: "2px dotted #C1C3C7",
                                        borderRadius: "10px",
                                        padding: "15px 15px",
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <Document />
                                            <div style={{ display: "flex", alignItems: 'center' }}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                                            </div>
                                        </div>

                                        <ButtonOutlined
                                            onClick={() => {
                                                window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');
                                            }}
                                            buttonName={t('MEETING.DOWNLOAD_FILE')}
                                            btnProps={{
                                                width: "150px",
                                            }}
                                        />
                                    </div> :
                                    <UploadFile
                                        onDrop={(file) => {
                                            handleUpdate(file, index);
                                        }}
                                        onDeleteFile={() => {
        

                                        }}
                                        noClick={false}

                                    />}
                                {mode !== 'VIEW' && <div style={{
                                    border: '1px solid #DDE1EB',
                                    borderRadius: '8px',
                                    padding: '16px',
                                }} onClick={() => {
                                    setForm({
                                        ...form, id_thesis_progress_file: form?.id_thesis_progress_file?.map((item: any, i: number) => {
                                            return i === index ? {} : item
                                        })
                                    })
                                }}>
                                    <Bag />
                                </div>}
                            </div>
                        )
                    })} */}
                </section>}



            {step === 1 &&
                <section className="my-4">
                    <Grid container spacing={2}>

                        <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('หมายเหตุ')}
                                placeholder={t('หมายเหตุ')}
                                value={form?.approve?.thesis_progress_approve_remark || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                disabled
                                multiline
                                minRow={6}
                                inputHeight={'auto'}
                            />
                        </Grid>
                        {/* {form?.approve?.thesis_progress_approve_status !== 'REJECT' && <Grid
                            item
                            xs={12}
                            md={12}
                            lg={12}
                            sx={{
                                alignSelf: "end",
                            }}
                        >
                            <InputTextField
                                heading={t('เปอร์เซ็นต์ความคืบหน้า')}
                                placeholder={t('เปอร์เซ็นต์ความคืบหน้า')}
                                value={form?.approve?.thesis_progress_approve_percent || ''}
                                onchange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                }}
                                helperText={
                                    ""
                                }
                                onkeypress={handleTypingNumber}
                                disabled
                            />
                        </Grid>
                        } */}


                    </Grid>

                    <section className="w-full mt-10">
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={
                                file_approve?.map((data: any, i: any) => {
                                    return renderData(data, i);
                                })
                            }
                            hidePagination
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </section>

                    {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '20px' }}>
                        <Typography variant='h6'>{t("ไฟล์แนบ")}</Typography>
                    </div>
                    {form?.approve?.file_approve?.map((item: any, index: number) => {
                        return (
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginTop: '10px', width: "100%" }}>

                                {item?.file_name ?
                                    <div style={{
                                        border: "2px dotted #C1C3C7",
                                        borderRadius: "10px",
                                        padding: "15px 15px",
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}>
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <Document />
                                            <div style={{ display: "flex", alignItems: 'center' }}>
                                                <Typography sx={{ fontSize: '16px', fontWeight: '500' }}>{item?.file_name}</Typography>
                               
                                            </div>
                                        </div>

                                        <ButtonOutlined
                                            onClick={() => {
                                           
                                                window.open(process.env.REACT_APP_FILE_BASE_API + '/' + item?.file_path + item?.file_name, '_blank');
                                            }}
                                            buttonName={t('MEETING.DOWNLOAD_FILE')}
                                            btnProps={{
                                                width: "150px",
                       
                                            }}
                                        />
                                    </div> :
                                    <UploadFile
                                        onDrop={(file) => {
                                            handleUpdate(file, index);
                                        }}
                                  
                                        onDeleteFile={() => {
                                       

                                        }}
                                        noClick={false}
                  

                                    />}

                            </div>
                        )
                    })} */}
                </section>}


            {mode === 'VIEW' ?
                <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                    <ButtonOutlined
                        onClick={() => {
                            // navigate(routeName.cms.MeetingCalendar);
                            navigate(routeName.students.EThesisProgress);
                        }}
                        buttonName="ย้อนกลับ"
                        btnProps={{
                            width: "150px",
                        }}
                    />


                </section> : <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                    <ButtonOutlined
                        onClick={() => {
                            // navigate(routeName.cms.MeetingCalendar);
                            navigate(routeName.students.EThesisProgress);
                        }}
                        buttonName="ย้อนกลับ"
                        btnProps={{
                            width: "150px",
                        }}
                    />


                    <ButtonPrimary
                        onClick={() => {
                            // handleSubmit(inputValueFormStudent.information);
                            handleSubmit()
                        }}
                        disabled={progress_data?.every((x) => x?.status == THESIS_PROGRESS_STATUS.INACTIVE)}
                        mode="success"
                        buttonName="ยืนยัน"
                        btnProps={{
                            width: "150px",
                        }}
                    />
                </section>}
        </div>
    )
}
